import Image from "next/image";
import { Link } from '@mui/material';
import NextLink from 'next/link';

const Logo = ({ mode = 'light'}) => {
    return (
        <div className="apex-logo">
            <Link href="/" component={NextLink} className={"headerLogo"}>
                <Image
                    src={ '/Logo' + ([ 'light', undefined ].includes(mode) ? 'Black' : 'White') + '.svg' }
                    alt="Apex Signals"
                    width="210"
                    height="39"
                />
            </Link>
        </div>
    );
};

export default Logo;